import { nextTurnstileToken, turnstileHeaders } from '@components/Turnstile/Turnstile';
import axios from '@hooks/useAxios';

import {
  PatientOrderingEligibilityRequest,
  PatientOrderingEligibilityResponse,
  PatientOrderingPaymentIntentRequest,
  PatientOrderingPaymentIntentResponse,
  PatientOrderingSubmitOrderRequest,
  PatientOrderingSubmitOrderResponse,
} from '../../types/test-ordering';

const PATIENT_TESTING_API_ROUTES = {
  getEligibility: '/patient-portal/ordering/eligibility',
  paymentIntent: '/patient-portal/ordering/payment-intent',
  submitOrder: '/patient-portal/ordering/submit',
};

export const getEligibility = async (
  payload: PatientOrderingEligibilityRequest,
): Promise<PatientOrderingEligibilityResponse> => {
  // Ensure we're not passing empty strings to the API
  const cleanedPayload: PatientOrderingEligibilityRequest = {
    ...payload,
    campaign_code: payload.campaign_code || null,
    promo_code: payload.promo_code || null,
  };

  const turnstileToken = await nextTurnstileToken();
  return axios
    .post(PATIENT_TESTING_API_ROUTES.getEligibility, cleanedPayload, {
      suppressGlobalErrorToast: true,
      headers: turnstileHeaders(turnstileToken),
    })
    .then(res => res.data);
};

export const createOrUpdatePaymentIntent = async (
  payload: PatientOrderingPaymentIntentRequest,
): Promise<PatientOrderingPaymentIntentResponse> => {
  // Ensure we're not passing empty strings to the API
  const cleanedPayload: PatientOrderingPaymentIntentRequest = {
    ...payload,
    campaign_code: payload.campaign_code || null,
    promo_code: payload.promo_code || null,
    payment_intent_id: payload.payment_intent_id || null,
  };

  const turnstileToken = await nextTurnstileToken();
  return axios
    .post(PATIENT_TESTING_API_ROUTES.paymentIntent, cleanedPayload, { headers: turnstileHeaders(turnstileToken) })
    .then(res => res.data);
};

export const submitOrder = async (
  payload: PatientOrderingSubmitOrderRequest,
): Promise<PatientOrderingSubmitOrderResponse> => {
  // Ensure we're not passing empty strings to the API
  const cleanedPayload: PatientOrderingSubmitOrderRequest = {
    ...payload,
    campaign_code: payload.campaign_code || null,
    promo_code: payload.promo_code || null,
    payment_intent_id: payload.payment_intent_id || null,
  };

  const turnstileToken = await nextTurnstileToken();
  return axios
    .post(PATIENT_TESTING_API_ROUTES.submitOrder, cleanedPayload, { headers: turnstileHeaders(turnstileToken) })
    .then(res => res.data);
};
